import styled from 'styled-components';
import {
  color,
  space,
  layout,
  typography,
  flexbox,
  border,
  position,
  background,
  shadow,
  grid,
} from 'styled-system';

export const Box = styled('div')(
  color,
  space,
  layout,
  typography,
  flexbox,
  border,
  position,
  background,
  shadow,
  grid
);
